export class VenueMap {
    timings: string = null;
    has_venue_map:boolean=false;
    venue_map_id:string=null;
    venueNote:string=null;
}


// WEBPACK FOOTER //
// /app/src/app/core/models/venue-detail.ts